module.exports = __webpack_public_path__ + "static/img/logo-dark.530b52ac.svg";